import { defineKey as T } from '@ha/intl';
import { ListingCostPayableAtValues } from '@ha/api/v2/types/Listing';

export const TRANSLATIONS_COST_LDP_BY_ATTRIBUTE: {
  payableAt: { [K in ListingCostPayableAtValues]: string };
} = {
  payableAt: {
    [ListingCostPayableAtValues.MOVE_IN]: T(
      'StructuredCosts.frequency.at_move_in',
    ),
    [ListingCostPayableAtValues.MOVE_OUT]: T(
      'StructuredCosts.frequency.at_move_out',
    ),
    [ListingCostPayableAtValues.ONE_OFF]: T(
      'StructuredCosts.create.frequency.oneoff',
    ),
    [ListingCostPayableAtValues.MONTHLY]: T(
      'StructuredCosts.frequency.monthly',
    ),
    [ListingCostPayableAtValues.BIMONTHLY]: T(
      'StructuredCosts.frequency.every_2_months',
    ),
    [ListingCostPayableAtValues.BIWEEKLY]: T(
      'StructuredCosts.frequency.biweekly',
    ),
    [ListingCostPayableAtValues.WEEKLY]: T('StructuredCosts.frequency.weekly'),
  },
};
